class BiltongBoysCartCaseControl {
  constructor(control) {
    this.control = control;
    this.decreaseButton = control.querySelector(
      '[data-bb-case-decrease]'
    );
    this.increaseButton = control.querySelector(
      '[data-bb-case-increase]'
    );
    this.display = control.querySelector(
      '[data-bb-case-display]'
    );
    this.realInput = control.querySelector(
      '[data-bb-real-cart-quantity]'
    );

    this.piecesPerSelection =
      Number.parseInt(control.dataset.piecesPerSelection, 10) || 1;

    this.caseLabel =
      control.dataset.caseLabel || 'case';

    this.bindEvents();
    this.updateDisplay();
  }

  bindEvents() {
    this.decreaseButton?.addEventListener('click', () => {
      this.changeCaseQuantity(-1);
    });

    this.increaseButton?.addEventListener('click', () => {
      this.changeCaseQuantity(1);
    });

    this.realInput?.addEventListener('change', () => {
      this.updateDisplay();
    });
  }

  getRawQuantity() {
    const quantity = Number.parseInt(
      this.realInput?.value,
      10
    );

    return Number.isInteger(quantity) && quantity >= 0
      ? quantity
      : 0;
  }

  getCaseQuantity() {
    return this.getRawQuantity() / this.piecesPerSelection;
  }

  changeCaseQuantity(direction) {
    if (!this.realInput || this.realInput.disabled) {
      return;
    }

    const currentRawQuantity = this.getRawQuantity();

    const nextRawQuantity = Math.max(
      0,
      currentRawQuantity +
        direction * this.piecesPerSelection
    );

    this.realInput.value = String(nextRawQuantity);
    this.updateDisplay();

    this.realInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  updateDisplay() {
    if (!this.display) {
      return;
    }

    const caseQuantity = this.getCaseQuantity();

    const formattedQuantity =
      Number.isInteger(caseQuantity)
        ? String(caseQuantity)
        : caseQuantity.toFixed(2).replace(/\.?0+$/, '');

    const pluralLabel =
      caseQuantity === 1
        ? this.caseLabel
        : `${this.caseLabel}s`;

    this.display.textContent =
      `${formattedQuantity} ${pluralLabel}`;

    if (this.decreaseButton) {
      this.decreaseButton.disabled =
        !this.realInput ||
        this.realInput.disabled ||
        this.getRawQuantity() <= 0;
    }

    if (this.increaseButton) {
      this.increaseButton.disabled =
        !this.realInput ||
        this.realInput.disabled;
    }
  }
}

function initialiseBiltongBoysCartCases(root = document) {
  root
    .querySelectorAll('[data-bb-cart-case-control]')
    .forEach((control) => {
      if (control.dataset.bbInitialised === 'true') {
        return;
      }

      control.dataset.bbInitialised = 'true';
      new BiltongBoysCartCaseControl(control);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseBiltongBoysCartCases();
});

document.addEventListener('shopify:section:load', (event) => {
  initialiseBiltongBoysCartCases(event.target);
});

document.addEventListener('cart:updated', () => {
  initialiseBiltongBoysCartCases();
});